module.exports = __webpack_public_path__ + "img/active-2.2be26ed5.svg";